const slugfy = (str, separador = '_') => {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove acentos
  var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç;";
  var to   = "aaaaaeeeeeiiiiooooouuuunc";
  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove caracter inválido
          .replace(/\s+/g, separador) // troca espaço por {separador}
          .replace(/-+/g, separador); // troca traços por {separador}

  return str;
}

const formatarOS = (id) => id ? `OS-${String(id).padStart(7, '0')}` : null;

export {
  slugfy,
  formatarOS
}